import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';

import { DIALOG_DATA, DialogRef } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { ConfirmDialogContentComponent } from '@pp/common';
import { DialogData } from '@pp/core/entities';

import { ConfirmShowNotificationsDialogData } from '../notifications.entities';

@Component({
  selector: 'pp-confirm-show-notifications',
  imports: [ConfirmDialogContentComponent, TranslateModule],
  templateUrl: './confirm-show-notifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmShowNotificationsComponent {
  readonly #dialogRef = inject(DialogRef);
  readonly #dialog = inject<DialogData<ConfirmShowNotificationsComponent, ConfirmShowNotificationsDialogData>>(DIALOG_DATA);

  setSettingsSuccessEffect = effect(() => {
    const success = this.#dialog.data.successSignal();
    if (success) {
      this.closeDialog(true);
    }
  });

  enableMode = this.#dialog.data.enableMode;
  description = this.enableMode
    ? 'notifications.dialog.showNotifications.enable.description'
    : 'notifications.dialog.showNotifications.disable.description';

  confirm(): void {
    const settings = { disable: !this.enableMode };
    this.#dialog.data.saveMethod(settings);
  }

  closeDialog(success?: boolean): void {
    this.#dialogRef.close(success);
  }
}
